import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { getActionReceiptDisplay } from "utils/HelperReceiptFunction";
import { PrintReceipt } from "./PrintReceipt";
export default function ReceiptFooterSubmit(param) {
    var setFieldValue = param.setFieldValue, modalReceiptModalState = param.modalReceiptModalState, values = param.values, formdisabled = param.formdisabled, setFormdisabled = param.setFormdisabled, companyInfo = param.companyInfo, options = param.options;
    var navigate = useNavigate();
    var componentRef = useRef();
    var handlePrint = useReactToPrint({
        content: function() {
            return componentRef.current;
        }
    });
    var setModalConfirmCancel = modalReceiptModalState.setModalConfirmCancel;
    var _useState = _sliced_to_array(useState(getActionReceiptDisplay({
        formdisabled: formdisabled,
        dimMstNewStatus: values.dimMstReceiptStatus,
        values: values
    })), 2), displaySubmitBtn = _useState[0], setDisplaySubmitBtn = _useState[1];
    useEffect(function() {
        setDisplaySubmitBtn(getActionReceiptDisplay({
            formdisabled: formdisabled,
            dimMstNewStatus: values.dimMstReceiptStatus,
            values: values
        }));
    }, [
        values.dimMstReceiptStatus,
        formdisabled,
        values.submitted_at
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow z-[10]",
        style: {
            minWidth: "1000px"
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body px-xl-3 d-flex justify-between",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "flex",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "flex gap-2",
                        children: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        display: "none"
                                    },
                                    children: /*#__PURE__*/ _jsx(PrintReceipt, {
                                        innerRef: componentRef,
                                        values: values,
                                        companyInfo: companyInfo
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Button, {
                                    onClick: handlePrint,
                                    type: "button",
                                    className: "btn-st-8 fs-14 border-0 px-3 me-3",
                                    disabled: displaySubmitBtn.canPrintStatus ? false : true,
                                    children: [
                                        /*#__PURE__*/ _jsx("i", {
                                            className: "iprinter"
                                        }),
                                        "พิมพ์เอกสาร"
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: function() {
                                navigate("/sale/receipt");
                            },
                            className: "btn-st-6 me-3 btn ms-auto",
                            children: "ย้อนกลับ"
                        }),
                        displaySubmitBtn.canDraftStatus && /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            onClick: function() {
                                var _options_branch;
                                // e.preventDefault();
                                setFieldValue("dim_mst_receipt_status_id", 1);
                                // Auto-set dim_branch_id if empty
                                if ((options === null || options === void 0 ? void 0 : (_options_branch = options.branch) === null || _options_branch === void 0 ? void 0 : _options_branch.length) === 1) {
                                    setFieldValue("dim_branch_id", 1);
                                }
                            },
                            className: "btn-st-3 me-3",
                            children: "บันทึกร่าง"
                        }),
                        displaySubmitBtn.canCancelStatus && /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: function() {
                                setModalConfirmCancel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            className: "bg-[#ff0000] text-white border-[#ff0000] me-3 btn",
                            children: "ยกเลิก"
                        }),
                        displaySubmitBtn.canApprovedStatus && /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            onClick: function() {
                                var _options_branch;
                                setFieldValue("dim_mst_receipt_status_id", 2);
                                // Auto-set dim_branch_id if empty
                                if ((options === null || options === void 0 ? void 0 : (_options_branch = options.branch) === null || _options_branch === void 0 ? void 0 : _options_branch.length) === 1) {
                                    setFieldValue("dim_branch_id", 1);
                                }
                            },
                            className: "",
                            children: "อนุมัติ"
                        })
                    ]
                })
            ]
        })
    });
}
